/** Tipos de Plataformas */
export interface PlataformaTipo {
    id: number;
    nome: string;
}

export const tipoERP: PlataformaTipo = {id: 1, nome: 'ERP'};
export const tipoEcommerce: PlataformaTipo = {id: 2, nome: 'E-commerce'};


export const tiposPlataformas: PlataformaTipo[] = [
    tipoERP,
    tipoEcommerce
];

/** Verifica se o tipo do Plataforma é ERP */
export function isTipoPlataformaERP(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === tipoERP.id;
}

/** Verifica se o tipo do Plataforma é ECommerce */
export function isTipoPlataformaEcommerce(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === tipoEcommerce.id;
}
